module.exports = __webpack_public_path__ + "static/media/eats_map_logo.dd82736f.png";